import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
} from "@material-ui/core";
import { Edit, Delete, Add } from "@material-ui/icons";
import rest from "../../rest";
import IconButtonStyled from "../general/IconButtonStyled";
import { useStylesGlobal } from "../../pages/GlobalStyle.css";
import { formatDate } from "../general/formateDate";
import textLabels from "../dataTable/textLabel";

export const dicoColorLevel = [
  "remarqueFaible",
  "remarqueModerer",
  "remarqueElever",
];
export const dicoLevel = ["Faible", "Modéré", "Élevé"];

const OngletRemarque = ({
  readOnly,
  idBenevole,
  benevSelectedName,
  benevSelectedFirstName,
}) => {
  const [remarks, setRemarks] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState({ Remarque: "", Level: 0 });
  const stylesGlobal = useStylesGlobal();

  useEffect(() => {
    rest
      .post("/benevols/remarques/liste.json", { idUser: idBenevole })
      .then((response) => {
        if (response.data.success && Array.isArray(response.data.remaques)) {
          setRemarks(response.data.remaques);
        } else if (response.data.error) {
          console.error(response.data.message);
        } else {
          console.error(
            "Data received is not an array or has unexpected format",
            response.data
          );
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the remarks!", error);
      });
  }, [idBenevole]);

  const handleAddRemark = () => {
    rest
      .post("/benevols/remarques/add.json", {
        idUser: idBenevole,
        remarque: dialogData,
      })
      .then((response) => {
        if (response.data.success) {
          setRemarks([...remarks, response.data.remarque]);
          setOpenDialog(false);
        } else {
          console.error("Error adding remark:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("There was an error adding the Remarque!", error);
      });
  };

  const handleEditRemark = (id) => {
    rest
      .post(`/benevols/remarques/modif.json`, {
        remarque: { ID: id, ...dialogData },
      })
      .then((response) => {
        if (response.data.success) {
          console.log(
            remarks.map((r) => (r.ID === id ? response.data.remarque : r))
          );
          setRemarks(
            remarks.map((r) => (r.ID === id ? response.data.remarque : r))
          );
          setOpenDialog(false);
        } else {
          console.error("Error editing remark:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("There was an error editing the Remarque!", error);
      });
  };

  const handleDeleteRemark = (remarque) => {
    rest
      .post(`/benevols/remarques/delete.json`, { ID: remarque.ID })
      .then((response) => {
        if (response.data.success) {
          setRemarks(remarks.filter((r) => r.ID !== remarque.ID));
          console.log("Error deleting");
        } else {
          console.error("Error deleting remark:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("There was an error deleting the Remarque!", error);
      });
  };

  const handleDialogOpen = (data = { Remarque: "", Level: 0, ID: null }) => {
    setDialogData(data);
    if (!readOnly) setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const renderImportanceLevel = (value) => {
    return (
      <Box
        component="span"
        sx={{
          borderRadius: "5px",
          color: "white",
          padding: "10px",
          width: 100,
          display: "inline-block",
          textAlign: "center",
        }}
        className={stylesGlobal[dicoColorLevel[value]]}
      >
        {dicoLevel[value]}
      </Box>
    );
  };

  const columns = [
    {
      name: "ID",
      label: "ID",
      options: {
        display: false,
        filter: false,
      },
    },
    {
      name: "Date",
      label: "Date",
      options: {
        customBodyRender: (vD) => `${formatDate(vD)}`,
      },
    },
    {
      name: "Remarque_PersonWriter",
      label: "Écris par",
      options: {
        customBodyRender: (val) => `${val.Firstname} ${val.Name}`,
      },
    },
    { name: "Remarque", label: "Remarque" },
    {
      name: "Level",
      label: "Niveau d'importance",
      options: {
        customBodyRender: (value) => renderImportanceLevel(value),
      },
    },
    {
      name: "actions",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex; // Index dans la vue actuelle
          const remarkData = tableMeta.currentTableData[rowIndex]?.data; // assurez-vous de récupérer les données correctement
          const remarque = {
            ID: remarkData[columns.findIndex((col) => col.name === "ID")], // Récupérer l'ID correctement
            Date: remarkData[columns.findIndex((col) => col.name === "Date")],
            Remarque:
              remarkData[columns.findIndex((col) => col.name === "Remarque")],
            Level: remarkData[columns.findIndex((col) => col.name === "Level")],
            Remarque_PersonWriter:
              remarkData[
                columns.findIndex((col) => col.name === "Remarque_PersonWriter")
              ],
          };

          return (
            <>
              {!readOnly && (
                <Box>
                  <IconButton onClick={() => handleDialogOpen(remarque)}>
                    <Edit color="primary" />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteRemark(remarque)}>
                    <Delete color="error" />
                  </IconButton>
                </Box>
              )}
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    textLabels: textLabels,
    customToolbar: () => (
      <TableTitle onAddClick={() => handleDialogOpen()} readOnly={readOnly} />
    ),
    sortOrder: {
      name: "Date",
      direction: "desc",
    },
    customSort: (data, colIndex, order) => {
      const sortDateIndex = columns.findIndex((col) => col.name === "Date");
      const sortIdIndex = columns.findIndex((col) => col.name === "id");

      return data.sort((a, b) => {
        const dateA = new Date(a.data[sortDateIndex]);
        const dateB = new Date(b.data[sortDateIndex]);
        if (dateA < dateB) return order === "desc" ? 1 : -1;
        if (dateA > dateB) return order === "desc" ? -1 : 1;

        // Si les dates sont identiques, trier par ID
        const idA = a.data[sortIdIndex];
        const idB = b.data[sortIdIndex];
        return (idA - idB) * (order === "asc" ? 1 : -1);
      });
    },
  };

  const TableTitle = ({ title, onAddClick, readOnly }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <span>{title}</span>
      {!readOnly && (
        <IconButtonStyled
          onClick={onAddClick}
          color="successBtn"
          style={{ with: 20, height: 32, padding: 5 }}
          tooltipTitle="Ajouter une remarque"
        >
          <Add />
        </IconButtonStyled>
      )}
    </div>
  );

  return (
    <div>
      <MUIDataTable
        title={`Remarques de ${benevSelectedFirstName} ${benevSelectedName}`}
        data={remarks}
        columns={columns}
        options={options}
      />
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>
          {dialogData.ID ? "Modifier la remarque" : "Ajouter une remarque"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remarque"
            multiline
            type="text"
            fullWidth
            variant="outlined"
            value={dialogData.Remarque}
            onChange={(e) =>
              setDialogData({ ...dialogData, Remarque: e.target.value })
            }
          />
          <FormControl
            fullWidth
            margin="dense"
            variant="outlined"
            label="Niveau d’importance"
          >
            <InputLabel>Niveau d’importance</InputLabel>
            <Select
              value={dialogData.Level || 0}
              onChange={(e) =>
                setDialogData({ ...dialogData, Level: e.target.value })
              }
            >
              {dicoLevel.map((label, index) => (
                <MenuItem key={index} value={index}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose}
            color="primary"
            variant="outlined"
          >
            Annuler
          </Button>
          <Button
            onClick={
              dialogData.ID
                ? () => handleEditRemark(dialogData.ID)
                : handleAddRemark
            }
            variant="contained"
            color="primary"
          >
            {dialogData.ID ? "Modifier" : "Ajouter"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OngletRemarque;
